import SingleLineTextField from "./SingleLineTextField";
import TextFieldLabel from "./TextFieldLabel";

export default function SingleLineTextFieldWithLabel({
  label,
  initialPosition = "top",
  ...inputProps
}) {
  const isLeft = initialPosition === "left";
  const containerClass = `flex ${isLeft ? "flex-row" : "flex-col"} gap-1`;

  return (
    <div className={containerClass}>
      <TextFieldLabel label={label} />
      <SingleLineTextField {...inputProps} />
    </div>
  );
}